import { Card, Container, Flex, Group, Loader, createStyles } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconDevicesBolt, IconFiles, IconGps, IconReportSearch } from '@tabler/icons-react'
import { TSAHero } from '@testsa-com/common/src/components/TSAHero'
import { StylesHelper } from '@testsa-com/common/src/helpers/Styles.helper'
import type { MenuLink } from '@testsa-com/common/src/types/Menu.type'
import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TSAQuickAccessButton } from '../../../../packages/common/src/components/TSAQuickAccessButton'
import { ICON_PROPS } from '../helpers/Menu.helper'
import { useUserStore } from '../stores/useUserStore'

const useStyles = createStyles(theme => ({
  card: {
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
  },

  title: {
    fontWeight: 700,
  },
}))

const Index: NextPage = () => {
  const { t } = useTranslation('pages')
  const { t: tc } = useTranslation('common')
  const { classes, theme } = useStyles()
  const router = useRouter()
  const mobileScreen = useMediaQuery(StylesHelper.MOBILE)
  const userStore = useUserStore()

  const links = useMemo(
    () =>
      [
        {
          link: '/projects/',
          label: tc('words.project_other'),
          icon: <IconFiles {...ICON_PROPS} />,
          IconElement: IconFiles,
        },
        {
          link: '/pollsters/',
          label: tc('words.pollster_other'),
          icon: <IconReportSearch {...ICON_PROPS} />,
          IconElement: IconReportSearch,
          permission: 'pollsters.list',
        },
        {
          link: '/equipments/',
          label: tc('words.equipment_one'),
          icon: <IconDevicesBolt {...ICON_PROPS} />,
          IconElement: IconDevicesBolt,
          permission: 'equipments.list',
        },
        {
          link: '/field/',
          label: tc('fieldOffice.title'),
          icon: <IconGps {...ICON_PROPS} />,
          IconElement: IconGps,
          permission: 'field.access',
        },
      ] as MenuLink[],
    [tc],
  )

  if (userStore.me?.type === 'clientUser') {
    router.push(`/dashboards/organisations/${userStore.me?.organization.id}`)

    return
  }

  if (!userStore.me) {
    return (
      <Group position="center" pt="xl">
        <Loader size="sm" />
      </Group>
    )
  }

  return (
    <>
      <TSAHero title={t('index.title')} description={t('index.description')} />
      <Container size="md">
        <Card withBorder radius="md" className={classes.card}>
          <Flex gap={16} wrap="wrap">
            {links.map((link, index) => (
              <TSAQuickAccessButton
                key={link.link}
                color={theme.colors.orange[6]}
                hasPermission={
                  typeof link.permission !== 'undefined'
                    ? userStore.isAuthorised(link.permission)
                    : true
                }
                style={{
                  flexBasis:
                    mobileScreen || (links.length % 2 && index === links.length - 1)
                      ? '100%'
                      : '49%',
                }}
                {...link}
              />
            ))}
          </Flex>
        </Card>
      </Container>
    </>
  )
}

export default Index
